import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Modal,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import classnames from "classnames"
import { URLS } from "../../Url"
import axios from "axios"

function State() {
  const [forms, setforms] = useState([])
  const [logo, setlogo] = useState([])
  const [SevicesImages, setSevicesImages] = useState([])
  const [fac, setfac] = useState([])

  const [Tags, setTags] = useState([])

  const [modal_small, setmodal_small] = useState(false)

  function tog_small() {
    setmodal_small(!modal_small)
  }

  useEffect(() => {
    GetOneActins()
  }, [])

  const [activeTab1, setactiveTab1] = useState("5")
  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  const history = useHistory()

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("ListingId")

  const GetOneActins = () => {
    const data = {
      id: Actinid,
    }

    var token = datas
    axios
      .post(URLS.GetByIdListing, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setforms(res.data.data)
        setfac(res.data.data.facilityDetails)
        setlogo(res.data.data.businessLogo[0])
        setTags(res.data.data.tag)
        setSevicesImages(res.data.data.serviceImg)
      })
  }

  const [form1, setform1] = useState([])

  const [form2, setform2] = useState([])

  const getpopup = data => {
    setform2(data)
    tog_small()
  }

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    Editstate()
  }

  const Editstate = () => {
    var token = datas
    const dataArray = {
      listingStatus: "rejected",
      rejectedReason: form1.rejectedReason,
    }
    axios
      .put(URLS.RejectListing + form2._id, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            GetOneActins()
            toast(res.data.message)
            setmodal_small(false)
            history.push("/UserListing")
            setform1({
              rejectedReason: "",
            })
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home" breadcrumbItem="Listing View" />
          <Row>
            <Col md={12}>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>

              {Roles?.PendingUserListingApproved == true ||
              Roles?.accessAll == true ? (
                <>
                  {forms.listingStatus == "rejected" ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        onClick={() => {
                          getpopup(forms)
                        }}
                        style={{ float: "right" }}
                        className="m-1 "
                        color="danger"
                      >
                        <div className="d-flex">
                          <i className="fas fa-user-lock px-1"></i>Reject
                        </div>
                      </Button>
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Card>
            <CardBody>
              <h5 className="text-primary"> {forms.listingCode} : </h5>
              <div className="">
                <Row className="mt-3">
                  <Col
                    md={4}
                    style={{
                      border: "1px #806530 solid",
                    }}
                  >
                    <div className="m-2">
                      <img
                        src={URLS.Base + logo}
                        height="250px"
                        width="100%"
                      ></img>
                    </div>
                  </Col>
                  <Col
                    md={8}
                    style={{
                      borderTop: "1px #806530 solid",
                      borderRight: "1px #806530 solid",
                      borderBottom: "1px #806530 solid",
                    }}
                  >
                    <div>
                      <div>
                        <h4 style={{ color: "black" }} className="pt-4">
                          {forms.name}
                        </h4>
                      </div>
                      <div className="pt-3">
                        <span>
                          <i
                            className="bx bx-map-pin text-danger m-1"
                            style={{ fontSize: "20px" }}
                          ></i>
                          {forms.address}, {forms.state}, {forms.city},
                          {forms.pincode}.
                        </span>
                      </div>
                      <div className="pt-3">
                        <span>
                          <i
                            className="bx bx-time text-danger m-1"
                            style={{ fontSize: "20px" }}
                          ></i>
                          {forms.dateEstablished}
                        </span>
                      </div>
                      <h4 style={{ color: "#806530" }} className="pt-3">
                        {/* Business Summary */}
                        Business Details
                      </h4>
                      {/* <p>{forms.aboutUs}</p> */}
                      <p>{forms.description}</p>

                      <p><b>Category : </b>{forms.categoryName}</p>
                      <p><b>Sub Category : </b>{forms.subcategoryName}</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <div>
                <Row>
                  <Col md={8}>
                    <div className="mt-5">
                      <Nav pills className="navtab-bg nav-justified">
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "5",
                            })}
                            onClick={() => {
                              toggle1("5")
                            }}
                          >
                            Over View
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "8",
                            })}
                            onClick={() => {
                              toggle1("8")
                            }}
                          >
                            Photos
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
            <div className="mb-5">
              <TabContent activeTab={activeTab1} className="p-3 text-muted">
                <TabPane tabId="5">
                  {/* <h4 style={{ color: "#806530" }}>Business Summary </h4> */}
                  {/* <h4 style={{ color: "#806530" }}>{forms.description} </h4> */}
                  <h4 style={{ color: "#806530" }}>About Us </h4>
                  <p>{forms.aboutUs}</p>
                  <hr></hr>
                  <h4 style={{ color: "#806530" }}>Address</h4>
                  <p>
                    {forms.address}, {forms.state}, {forms.city},{forms.pincode}
                  </p>
                  <hr></hr>
                  <div>
                    <h5 className="pt-3" style={{ color: "#806530" }}>
                      Contact
                    </h5>
                    <p> {forms.contact} </p>
                  </div>
                  <div>
                    <h5 className="pt-3" style={{ color: "#806530" }}>
                      Email
                    </h5>
                    <p> {forms.email} </p>
                  </div>
                  <div>
                    <h5 className="pt-3" style={{ color: "#806530" }}>
                      GST Number
                    </h5>
                    <p> {forms.GSTINnumber} </p>
                  </div>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Business Hours</h5>
                    <h6>
                      Open Hours : 
                      <span>
                        {forms.openTime} / {forms.closeTime}
                      </span>
                    </h6>
                  </div>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Website </h5>
                    <p> {forms.website}</p>
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }} className="mb-4">
                      Facilities
                    </h5>
                    {fac.map((data, key) => (
                      <Col md="4" key={key}>
                        <p style={{ color: "black" }}>
                          <span className="bx bx-check-circle"></span>
                          {data.label}
                        </p>
                      </Col>
                    ))}
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }} className="mb-4">
                      Tags
                    </h5>
                    {Tags.map((data, key) => (
                      <Button
                        key={key}
                        className="btn-sm m-1"
                        outline
                        style={{ backgroundShadow: "none" }}
                      >
                        #{data}
                      </Button>
                    ))}
                  </div>
                  <hr></hr>
                  <div className="pt-3">
                    <h5 style={{ color: "#806530" }}>Social Media </h5>
                    <div className="mb-3 row mt-3">
                      <div className="col-md-12">
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            FaceBook:
                            <a
                              href={forms.facebook}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.facebook}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Instagram:
                            <a
                              href={forms.instagram}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.instagram}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Twitter:
                            <a
                              href={forms.twitter}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.twitter}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            linkedIn :
                            <a
                              href={forms.linkedIn}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.linkedIn}
                            </a>
                          </p>
                        </div>
                        <div>
                          <p className="text-muted">
                            <i className="fa fa-caret-right font-size-16 align-middle text-primary me-2" />
                            Youtube :
                            <a
                              href={forms.youtube}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {forms.youtube}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="8">
                  <h4 style={{ color: "#806530" }}>Photos </h4>
                  <Row>
                    {SevicesImages.map((data, key) => (
                      <Col md="4" key={key} className="mt-5">
                        <img
                          src={URLS.Base + data}
                          height="300px"
                          width="100%"
                        ></img>
                      </Col>
                    ))}
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </Card>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small}
          toggle={() => {
            tog_small()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              Update User Listing
            </h5>
            <button
              onClick={() => {
                setmodal_small(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              onSubmit={e => {
                handleSubmit1(e)
              }}
            >
              <Col md={12}>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input3">
                    Reason <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    type="text"
                    rows="3"
                    className="form-control "
                    id="basicpill-firstname-input1"
                    placeholder="Enter Reject Reason"
                    required
                    value={form1.rejectedReason}
                    name="rejectedReason"
                    onChange={e => {
                      handleChange1(e)
                    }}
                  />
                </div>
              </Col>
              <div style={{ float: "right" }}>
                <Button
                  onClick={() => {
                    setmodal_small(false)
                  }}
                  color="danger"
                  type="button"
                >
                  Cancel <i className="fas fa-times-circle"></i>
                </Button>
                <Button className="m-1" color="primary" type="submit">
                  Submit <i className="fas fa-check-circle"></i>
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default State
